export enum OrderStatusType {
  None,
  Pending,
  PendingActivation,
  FailedActivation,
  Active,
  Completed,
  Cancelled,
}

export type SampleSummary = {
  uploaded: number;
  processing: number;
  finished: number;
  isProcessingWithWarning: boolean;
  latestProcessed: Date | undefined;
};

export type SampleReportStatus = 'Active' | 'Obsolete';

export type SampleReport = {
  id: string;
  reportNumber: string;
  reportType: 'CDx';
  name: string;
  status: SampleReportStatus;
  created: Date;
  orderNumber: string;
  sampleName: string;
};

export interface IDownloadSampleReport {
  created: Date;
  documentType: string;
  externalSubjectId: string;
  id: string;
  name: string;
  orderTestId: string;
  status: string;
}

export type SampleType = 'ID' | 'MRD' | null;

export type SampleProcessingStatus =
  | 'Uploaded'
  | 'Processing'
  | 'ProcessingWithWarning'
  | 'Finished';

export type SampleDetail = {
  sampleName: string;
  patientId: string;
  sampleId: string;
  collectionDate: string | null;
  testType: SampleType;
  status: SampleProcessingStatus;
  qcStatus: 'Pass' | 'Fail' | 'Cancelled' | 'Pending';
  resultDate: string;
  reports: SampleReport[];
};

export type Order = {
  orderNumber: string;
  status: OrderStatusType;
  description: string;
  created: Date;
  sampleSummary: SampleSummary;
};

export type OrderWithSamples = Order & {
  samples: SampleDetail[];
};
